import axios from "axios";

function instance() {
  const hostname = window.location.hostname;
  return axios.create({
    baseURL: `http://${hostname}:${+window.location.port}/api`, //For Production
    //baseURL: `http://${hostname}:${+window.location.port - 1}`, //For Test
    headers: {
      authorization: "jwt " + localStorage.getItem("jwt"),
      "content-type": "application/json",
    },
  });
}

export default instance;
